"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = exports.MyOrderClass = void 0;
var _react = _interopRequireDefault(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _reactSvg = require("react-svg");
var MyOrderClass = 'dropdown__item-list__my-orders';
exports.MyOrderClass = MyOrderClass;
var MyAccountItemList = function MyAccountItemList(props) {
  var soldTo = (0, _get.default)(props, ['userDetails', 'soldTo'], []);
  var itemList = (0, _get.default)(props, ['itemList'], {});
  var full = 'FULL_ENABLED';
  var partial = 'PARTIAL_ENABLED';
  var disabled = 'DISABLED';
  var ePRocMyAccount = (0, _get.default)(props, ['ePRocMyAccount'], false);
  var soldToStatus = function soldToStatus() {
    return !!soldTo.length;
  };
  var currentState = function currentState() {
    return full;
  };
  var isPartialState = function isPartialState() {
    return currentState() === partial;
  };
  var isDisabledState = function isDisabledState() {
    return currentState() === disabled;
  };
  var shouldRender = function shouldRender(listItemClass) {
    return !(listItemClass === MyOrderClass && isDisabledState() || listItemClass === MyOrderClass && isPartialState() && !soldToStatus());
  };
  var listItems = Object.keys(itemList).map(function (key) {
    var _itemList$key = itemList[key],
      text = _itemList$key.text,
      url = _itemList$key.url,
      isDisabled = _itemList$key.isDisabled;
    var target = itemList[key].target || '_self';
    var listItemClass = itemList[key].class;
    var linkIcon = itemList[key].linkIcon || '';
    var linkOnClick = itemList[key].linkOnClick;
    var textAfterLink = itemList[key].textAfterLink || '';
    var isDisplayHrLine = itemList[key].isDisplayHrLine || false;
    return _react.default.createElement(_react.default.Fragment, null, isDisplayHrLine && _react.default.createElement("hr", {
      className: "my-account-dropdown__hr"
    }), _react.default.createElement("div", {
      key: key,
      className: "my-account-dropdown__item-list",
      "data-locator": "my-account-dropdown-list"
    }, shouldRender(listItemClass) && !isDisabled && _react.default.createElement("a", {
      className: "my-account-dropdown__item-list--link " + listItemClass,
      "data-locator": listItemClass + "-link",
      href: url,
      target: target,
      onClick: function onClick(e) {
        if (linkOnClick) {
          linkOnClick(e);
        }
      }
    }, linkIcon && _react.default.createElement(_reactSvg.ReactSVG, {
      "aria-hidden": "true",
      src: linkIcon,
      wrapper: "span",
      "data-locator": listItemClass + "-icon"
    }), _react.default.createElement("span", {
      "data-locator": listItemClass + "-link-text"
    }, text)), textAfterLink && _react.default.createElement("span", {
      className: listItemClass + "__text",
      "data-locator": listItemClass + "-text"
    }, " " + textAfterLink)));
  });
  return _react.default.createElement(_react.default.Fragment, null, listItems, !ePRocMyAccount && itemList.length > 0 && _react.default.createElement("hr", {
    className: "my-account-dropdown__hr"
  }));
};
var _default = MyAccountItemList;
exports.default = _default;